import ApiService from "./api.service";

const Verify = {

	push(id) {
		return ApiService.post(`verify/push-to-verify/${id}`, {}).then(response => response.data);
	},
	list() {
		return ApiService.post(`verify/list/verifies`, {}).then(response => response.data);
	},
	approve(id) {
		return ApiService.post(`verify/${id}`, {}).then(response => response.data)
	}


};
export default Verify;
